import { render, staticRenderFns } from "./luckyredpacketexchange.vue?vue&type=template&id=466f998e"
import script from "./luckyredpacketexchange.vue?vue&type=script&lang=js"
export * from "./luckyredpacketexchange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports